var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overlay"},[_vm._t("default"),(_vm.isLoading)?_c('div',[_c('div',{staticClass:"loading"}),_c('div',{staticClass:"indicator"},[_c('loader',{attrs:{"size":_vm.spinnerSize,"color":_vm.spinnerColor}})],1)]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }